import type { RootState } from '~features';
import type { AgreementType } from '~types/AgreementTypes';

const selectAgreementConfig = (state: RootState): AgreementType => state.agreementsConfig.agreement;

const selectAgreementConfigIsLoading = (state: RootState): boolean => state.agreementsConfig.isLoading;

export { selectAgreementConfig, selectAgreementConfigIsLoading };
